import Config from "../../Common/config";

const AdminAllUsers = ({ allUsers }) => {
  const baseArtistURL = Config().ArtistPhotoUrl;
  return (
    <div className="row adminRow">
      <h3>Teder Users</h3>
      <div className="col-md-12">
        <table className="table tableWhite">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Photo</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">User Type</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">City</th>
              <th scope="col">State</th>
              <th scope="col">Country</th>
              <th scope="col">Stage Name</th>
              <th scope="col">Create Date</th>
              <th scope="col">Genres</th>
            </tr>
          </thead>
          <tbody>
            {allUsers && allUsers.length ? (
              allUsers.map((item) => (
                <tr key={item.CreatedDate}>
                  <td>{item.ArtistID}</td>
                  <td>
                    <img
                      width="50"
                      height="50"
                      src={baseArtistURL + item.PhotoPath}
                      alt="showPhoto"
                    />
                  </td>
                  <td>{item.FirstName}</td>
                  <td>{item.LastName}</td>
                  <td>{item.UserType}</td>
                  <td>{item.Email}</td>
                  <td>{item.PhoneNo}</td>
                  <td>{item.City}</td>
                  <td>{item.State}</td>
                  <td>{item.Country}</td>
                  <td>{item.StageName}</td>
                  <td>{item.CreatedDate}</td>
                  <td>{item.Genres}</td>
                </tr>
              ))
            ) : (
              <tr></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAllUsers;
